import { Component,Output, EventEmitter, } from '@angular/core';
import {AuthService} from '../../../auth-guard/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { FccpResetpassword } from 'app/routes/sessions/FCCP/Fccp-component/resetpassword/fccp-resetpassword';
import { Editprofile } from 'app/routes/sessions/FCCP/Fccp-component/editprofile/editprofile';
@Component({
  selector: 'app-user',
  template: `
    <button
      mat-button
      class="matero-toolbar-button matero-avatar-button"
      href="javascript:void(0)"
      [matMenuTriggerFor]="menu"
    >
      
      <span class="matero-username" fxHide.lt-sm>{{username}}</span>
    </button>

    <mat-menu #menu="matMenu">
      <a (click)="editprofile()" mat-menu-item>
        <mat-icon>edit</mat-icon>
        <span>Edit Profile</span>
      </a>

      <a (click)="changepassword()" mat-menu-item>
        <mat-icon>vpn_key</mat-icon>
        <span>Change Password</span>
      </a>
      <a (click)="emitshowsetting()" mat-menu-item>
      <mat-icon>settings</mat-icon>
      <span>Settings</span>
      </a>
      
      <a (click)="logouthandler()" mat-menu-item>
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </a>
    </mat-menu>
  `,
})
// <a routerLink="/profile/overview" mat-menu-item>
//         <mat-icon>account_circle</mat-icon>
//         <span>Profile</span>
//       </a>
// <a routerLink="/profile/settings" mat-menu-item>
//         <mat-icon>settings</mat-icon>
//         <span>Settings</span>
//       </a>
export class UserComponent {
  username:any;
  @Output() showsetting = new EventEmitter<object>();

  constructor(public auth:AuthService,public dialog: MatDialog)
  {
  this.username=window.sessionStorage.getItem('username')+' '+this.auth.getstoragedtl().last_name;
 
  }

  emitshowsetting()
  {
    
    let showsettingpanel:any=true;
    this.showsetting.emit(showsettingpanel);
  }

  logouthandler()
  {
    this.auth.logout();
  }
editprofile()
{
  this.dialog.open(Editprofile,{width:'400px'});
}
changepassword()
{
  const dialogRef = this.dialog.open(FccpResetpassword,{
    width: '400px',
   
    
   
  });
}
}
